
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import {  IDocumentPayloadType } from '../../../types/api/document-types';


export async function detailDocument(id:string): Promise<AxiosResponse<TResponse<IDocumentPayloadType>>> {
    return axios.get(`${API_ENDPOINTS.DOCUMENT_DETAIL}/${id}`)
}


export async function documentList(qData: QData): Promise<AxiosResponse<TResponseWithQData<IDocumentPayloadType[]>>> {
    return axios.get(API_ENDPOINTS.DOCUMENT_LIST, {
        params: qData
    })
}


export async function updateDocumentStatus(
  data: IDocumentPayloadType
): Promise<AxiosResponse<TResponse<IDocumentPayloadType>>> {
  return axios.put<TResponse<IDocumentPayloadType>>(
    `${API_ENDPOINTS.DOCUMENT_UPDATE}/${data?._id}`,
    data
  );
}



